import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unselect',
    standalone: false
})
export class UnselectPipe implements PipeTransform {
    transform(value: any[]): any[] {
        if (!Array.isArray(value)) {
            return value;
        }
        return value.map(item => {
            if (item.selected === true) {
                return { ...item, selected: false };
            }
            return item;
        });
    }
}
